 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"module/session-module~module/ui-examples-module~playerProfiles":"module/session-module~module/ui-examples-module~playerProfiles","module/ui-examples-module":"module/ui-examples-module","module/dev-tools-module":"module/dev-tools-module","module/link-handler-module":"module/link-handler-module","module/login-extended-module":"module/login-extended-module","module/login-simple-module":"module/login-simple-module","module/login-static-plans-module":"module/login-static-plans-module","module/module-sample-module":"module/module-sample-module","module/player-profiles-module":"module/player-profiles-module","module/players-module":"module/players-module","module/service-plan-module":"module/service-plan-module","module/session-module~playerProfiles":"module/session-module~playerProfiles","module/session-module":"module/session-module","module/stripe-elements-module":"module/stripe-elements-module","module/user-profile-module":"module/user-profile-module","module/video-library-module":"module/video-library-module","playerProfiles":"playerProfiles","playerProfilesPitching":"playerProfilesPitching"}[chunkId]||chunkId) + "." + {"chunk-2812015a":"56a05eb2","chunk-2d0b6525":"b8fc4861","chunk-2d0b8ea1":"eadb37c9","chunk-2d0b92a3":"8488f01b","chunk-2d0e5afb":"ab002e72","chunk-2d21ab85":"83fb6758","chunk-2d2226ea":"0c3cebee","chunk-2d228e42":"3a15b145","chunk-31544b7e":"b7495c97","chunk-ddc83d46":"5eb31686","module/session-module~module/ui-examples-module~playerProfiles":"faa93d35","module/ui-examples-module":"e56e1e1c","module/dev-tools-module":"f8a8ffe8","module/link-handler-module":"2ec1d23a","module/login-extended-module":"3e3ffbc0","module/login-simple-module":"0fed17bc","module/login-static-plans-module":"07eeeddd","module/module-sample-module":"676d16b3","module/player-profiles-module":"4371e059","module/players-module":"8fcb2d43","module/service-plan-module":"7aadb1b2","chunk-7e90b09b":"fabb8fa6","module/session-module~playerProfiles":"eccbc72f","chunk-8570d536":"92dc8c00","module/session-module":"ceb3a56c","module/stripe-elements-module":"0febb95e","module/user-profile-module":"cb342b99","module/video-library-module":"d2af0cca","chunk-752cc4b8":"12cc119d","chunk-2d0dd779":"4de0ce8c","chunk-2d22d3e6":"aa11b664","chunk-5881e270":"95097360","chunk-2c3b3647":"e9c2bfa1","chunk-a82fdbbc":"88189810","chunk-2cbebffa":"c2988b4e","chunk-38524dea":"49ba86a2","chunk-5d0fe532":"0efec8a1","chunk-b4cc4a7c":"d8cb65a0","chunk-997156b8":"93a3d601","chunk-e21bc94c":"6faff561","chunk-e537da40":"a623bd37","chunk-5f8909e0":"f28354b2","chunk-2d0e9810":"79ea97a3","chunk-734b0912":"45d1e8e4","chunk-3d19f318":"c58d5bf1","chunk-0c7c26cf":"47c820bc","chunk-a740290e":"8b3c0327","chunk-45556cc8":"afd5f932","chunk-7147ba55":"9bff5ec4","chunk-ab92cb86":"715c60f7","playerProfiles":"36b1a5bd","chunk-038fd197":"2f746b62","chunk-2d0c209e":"1bcbb267","chunk-1ce3b3c9":"acf39f53","chunk-6bc322a0":"c000b481","chunk-b52a8adc":"53d23c6d","chunk-2b776479":"03c383e8","chunk-9c592e70":"5118cf88","chunk-37ae46d8":"5d615a27","chunk-641d33e8":"bb908599","chunk-755b623e":"6e4ea8bf","chunk-23659af4":"0e817cd6","chunk-57f76ee3":"61ecafd5","chunk-4084c38e":"8ae6cdba","chunk-6d28a3c3":"5329bdf5","chunk-8d441de6":"558bcfd6","chunk-638e0714":"effd0e7c","chunk-2730db46":"9b2e6d97","chunk-826d4018":"dd728b20","chunk-d9ea9456":"6804c272","playerProfilesPitching":"9ddb891b","chunk-130caaae":"8f3f0aa6","chunk-2a79766b":"d610e57e","chunk-6d6d1245":"bd805c25","chunk-2d0a402d":"78638a3d","chunk-2d0b639a":"69dcfdcf","chunk-2d0c7a96":"a723c744","chunk-2d0cb6f5":"d00e8f97","chunk-2d0cc9d7":"ead2119c","chunk-2d0d0f96":"8d8f9415","chunk-2d0de942":"6f54ea5a","chunk-2d0e53d3":"271bae8d","chunk-2d219fb9":"7d8ca6fa","chunk-2d2297a7":"d16a51c0","chunk-2d22e156":"1549c2ca","chunk-5e474678":"3aff561b","chunk-2d225480":"d1ec0d29","chunk-7164b8d0":"a26521da","chunk-017d4b30":"056b6293","chunk-2d21a3a8":"4420e699","chunk-2d22c8c5":"4c7b0fef","chunk-6207eeee":"135cecdc","chunk-2d0cfb41":"933f309f","chunk-2d2174bc":"76a80fd7","chunk-2d217ea7":"e896e974","chunk-3bc15430":"1e58fe1d","chunk-fbc2fb46":"39ca6d6f","chunk-7539b206":"ccedb078","chunk-2d2255f6":"268d4a48","chunk-36829633":"1da602e4","chunk-60dff7ba":"459f8def"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-2812015a":1,"chunk-31544b7e":1,"chunk-ddc83d46":1,"module/session-module~module/ui-examples-module~playerProfiles":1,"module/ui-examples-module":1,"chunk-7e90b09b":1,"module/session-module~playerProfiles":1,"chunk-8570d536":1,"module/session-module":1,"chunk-752cc4b8":1,"chunk-5881e270":1,"chunk-2c3b3647":1,"chunk-a82fdbbc":1,"chunk-2cbebffa":1,"chunk-38524dea":1,"chunk-5d0fe532":1,"chunk-b4cc4a7c":1,"chunk-997156b8":1,"chunk-e21bc94c":1,"chunk-5f8909e0":1,"chunk-734b0912":1,"chunk-3d19f318":1,"chunk-0c7c26cf":1,"chunk-a740290e":1,"chunk-45556cc8":1,"playerProfiles":1,"chunk-038fd197":1,"chunk-1ce3b3c9":1,"chunk-2b776479":1,"chunk-9c592e70":1,"chunk-37ae46d8":1,"chunk-641d33e8":1,"chunk-23659af4":1,"chunk-57f76ee3":1,"chunk-4084c38e":1,"chunk-8d441de6":1,"chunk-638e0714":1,"chunk-2730db46":1,"chunk-826d4018":1,"chunk-d9ea9456":1,"playerProfilesPitching":1,"chunk-130caaae":1,"chunk-5e474678":1,"chunk-7164b8d0":1,"chunk-017d4b30":1,"chunk-fbc2fb46":1,"chunk-7539b206":1,"chunk-36829633":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"module/session-module~module/ui-examples-module~playerProfiles":"module/session-module~module/ui-examples-module~playerProfiles","module/ui-examples-module":"module/ui-examples-module","module/dev-tools-module":"module/dev-tools-module","module/link-handler-module":"module/link-handler-module","module/login-extended-module":"module/login-extended-module","module/login-simple-module":"module/login-simple-module","module/login-static-plans-module":"module/login-static-plans-module","module/module-sample-module":"module/module-sample-module","module/player-profiles-module":"module/player-profiles-module","module/players-module":"module/players-module","module/service-plan-module":"module/service-plan-module","module/session-module~playerProfiles":"module/session-module~playerProfiles","module/session-module":"module/session-module","module/stripe-elements-module":"module/stripe-elements-module","module/user-profile-module":"module/user-profile-module","module/video-library-module":"module/video-library-module","playerProfiles":"playerProfiles","playerProfilesPitching":"playerProfilesPitching"}[chunkId]||chunkId) + "." + {"chunk-2812015a":"5cce4f48","chunk-2d0b6525":"31d6cfe0","chunk-2d0b8ea1":"31d6cfe0","chunk-2d0b92a3":"31d6cfe0","chunk-2d0e5afb":"31d6cfe0","chunk-2d21ab85":"31d6cfe0","chunk-2d2226ea":"31d6cfe0","chunk-2d228e42":"31d6cfe0","chunk-31544b7e":"85918756","chunk-ddc83d46":"7dd7833a","module/session-module~module/ui-examples-module~playerProfiles":"53544be3","module/ui-examples-module":"e3368af2","module/dev-tools-module":"31d6cfe0","module/link-handler-module":"31d6cfe0","module/login-extended-module":"31d6cfe0","module/login-simple-module":"31d6cfe0","module/login-static-plans-module":"31d6cfe0","module/module-sample-module":"31d6cfe0","module/player-profiles-module":"31d6cfe0","module/players-module":"31d6cfe0","module/service-plan-module":"31d6cfe0","chunk-7e90b09b":"d3c3b211","module/session-module~playerProfiles":"04619cef","chunk-8570d536":"d92dee1d","module/session-module":"6172486c","module/stripe-elements-module":"31d6cfe0","module/user-profile-module":"31d6cfe0","module/video-library-module":"31d6cfe0","chunk-752cc4b8":"50b087b2","chunk-2d0dd779":"31d6cfe0","chunk-2d22d3e6":"31d6cfe0","chunk-5881e270":"2d8487ab","chunk-2c3b3647":"901a92fc","chunk-a82fdbbc":"4f07bc82","chunk-2cbebffa":"35451e5a","chunk-38524dea":"ee79ada5","chunk-5d0fe532":"6e180f65","chunk-b4cc4a7c":"006eb267","chunk-997156b8":"f748379a","chunk-e21bc94c":"95db5e62","chunk-e537da40":"31d6cfe0","chunk-5f8909e0":"76f8ccbd","chunk-2d0e9810":"31d6cfe0","chunk-734b0912":"2fa0d4f2","chunk-3d19f318":"772f15df","chunk-0c7c26cf":"8c59da5a","chunk-a740290e":"927f2f16","chunk-45556cc8":"4615b5fa","chunk-7147ba55":"31d6cfe0","chunk-ab92cb86":"31d6cfe0","playerProfiles":"3347400b","chunk-038fd197":"731f251d","chunk-2d0c209e":"31d6cfe0","chunk-1ce3b3c9":"69cffa1b","chunk-6bc322a0":"31d6cfe0","chunk-b52a8adc":"31d6cfe0","chunk-2b776479":"f7367c4f","chunk-9c592e70":"bb6cc5d1","chunk-37ae46d8":"594cce72","chunk-641d33e8":"03f8eeb9","chunk-755b623e":"31d6cfe0","chunk-23659af4":"6b2858ab","chunk-57f76ee3":"a0aea391","chunk-4084c38e":"08637d91","chunk-6d28a3c3":"31d6cfe0","chunk-8d441de6":"d928eceb","chunk-638e0714":"64f68eee","chunk-2730db46":"df80d9f4","chunk-826d4018":"bfa504d1","chunk-d9ea9456":"c876b5f4","playerProfilesPitching":"bf678bd7","chunk-130caaae":"c876b5f4","chunk-2a79766b":"31d6cfe0","chunk-6d6d1245":"31d6cfe0","chunk-2d0a402d":"31d6cfe0","chunk-2d0b639a":"31d6cfe0","chunk-2d0c7a96":"31d6cfe0","chunk-2d0cb6f5":"31d6cfe0","chunk-2d0cc9d7":"31d6cfe0","chunk-2d0d0f96":"31d6cfe0","chunk-2d0de942":"31d6cfe0","chunk-2d0e53d3":"31d6cfe0","chunk-2d219fb9":"31d6cfe0","chunk-2d2297a7":"31d6cfe0","chunk-2d22e156":"31d6cfe0","chunk-5e474678":"d928eceb","chunk-2d225480":"31d6cfe0","chunk-7164b8d0":"3d865e26","chunk-017d4b30":"611dce55","chunk-2d21a3a8":"31d6cfe0","chunk-2d22c8c5":"31d6cfe0","chunk-6207eeee":"31d6cfe0","chunk-2d0cfb41":"31d6cfe0","chunk-2d2174bc":"31d6cfe0","chunk-2d217ea7":"31d6cfe0","chunk-3bc15430":"31d6cfe0","chunk-fbc2fb46":"8244edfa","chunk-7539b206":"0bacb455","chunk-2d2255f6":"31d6cfe0","chunk-36829633":"a98d6761","chunk-60dff7ba":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
